module.exports = __webpack_public_path__ + "static/media/rivers.8efcf443.svg";